import React, { useState, useRef, useEffect } from "react";
import { X, Scale } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const LEGAL = {
  de: {
    impressum_title: "Impressum",
    privacy_title: "Datenschutz",
    terms_title: "AGB",
    legal_tooltip: "Rechtliches",
    impressum: `Impressum

Plandirekt24
Unternehmergesellschaft (haftungsbeschränkt)

An der Hermannsquelle 12
23879 Mölln
Deutschland

E-Mail: info@wlbusinesscomputing.com
Telefon: +49 171 1277531
Website: beauly.club`,

    privacy: `Datenschutzerklärung

1. Allgemeines
Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir verarbeiten Daten ausschließlich im Einklang mit der DSGVO. Diese Erklärung informiert über Art, Umfang und Zweck der Datenverarbeitung auf der Plattform Beauly.

2. Verantwortlicher
Plandirekt24 UG (haftungsbeschränkt)
Jonathan Weiß
An der Hermannsquelle 12, 23879 Mölln, Deutschland
E-Mail: info@wlbusinesscomputing.com

3. Welche Daten wir verarbeiten
Bei Registrierung: E-Mail-Adresse, Passwort, optional Name
Bei Nutzung: Hochgeladene Fotos, Chatverläufe, Nutzungsdaten
Technisch: IP-Adresse, Browsertyp, Zugriffszeitpunkt

Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).

4. Hochgeladene Fotos
Fotos werden zur KI-Analyse verarbeitet und nicht an Dritte weitergegeben. Der Nutzer ist dafür verantwortlich, dass er zur Übermittlung berechtigt ist.

5. Chatverläufe
Chatverläufe werden gespeichert, solange das Konto besteht. Nutzer können diese jederzeit löschen. Bei Kontolöschung werden alle Daten entfernt.

6. KI-Verarbeitung
Beauly nutzt KI-Systeme zur Analyse und Bildgenerierung. Ergebnisse sind automatisiert erzeugt und dienen als Orientierung — keine fachliche Beratung. Es findet keine automatisierte Entscheidungsfindung gemäß Art. 22 DSGVO statt.

7. Dienstleister
Wir arbeiten mit technischen Dienstleistern für Hosting, Datenbank und KI-Verarbeitung. Es bestehen Auftragsverarbeitungsverträge gemäß Art. 28 DSGVO.

8. Cookies
Beauly verwendet keine Tracking- oder Werbe-Cookies.

9. Speicherdauer
Daten werden nur so lange gespeichert, wie erforderlich. Bei Kontolöschung werden alle Daten gelöscht. Zahlungsdaten können aufgrund gesetzlicher Pflichten bis zu 10 Jahre aufbewahrt werden.

10. Ihre Rechte
Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit und Widerspruch. Kontakt: info@wlbusinesscomputing.com

11. Änderungen
Wir behalten uns vor, diese Erklärung bei Bedarf anzupassen. Die aktuelle Version ist stets auf der Website verfügbar.`,

    terms: `Allgemeine Geschäftsbedingungen

1. Geltungsbereich
Diese AGB gelten für die Nutzung der Plattform Beauly, betrieben von Plandirekt24 UG (haftungsbeschränkt), An der Hermannsquelle 12, 23879 Mölln. Mit der Registrierung erkennen Sie diese AGB an.

2. Leistungsbeschreibung
Beauly ist eine KI-gestützte Plattform zur Analyse und Visualisierung von Styling- und Appearance-Optimierungen. Der Dienst umfasst KI-Analyse, Bildgenerierung und personalisierte Empfehlungen. Eine ununterbrochene Verfügbarkeit wird nicht garantiert.

3. Registrierung
Zur Nutzung ist eine Registrierung mit wahrheitsgemäßen Angaben erforderlich. Zugangsdaten sind geheim zu halten. Mindestalter: 18 Jahre.

4. Preise und Zahlung
Die Nutzung von Beauly ist kostenpflichtig. Details zu Preisen und Abonnements sind auf der Plattform einsehbar. Alle Preise verstehen sich zzgl. MwSt. Die Zahlung erfolgt über externe Zahlungsdienstleister. Bereits gezahlte Beträge werden nicht erstattet.

5. Nutzungspflichten
Die Nutzung für illegale Zwecke, Verbreitung von Schadsoftware, automatisierte Massenanfragen und Weitergabe von Zugangsdaten ist untersagt. Bei Verstößen kann der Zugang gesperrt werden.

6. Hochgeladene Inhalte
Die Rechte an hochgeladenen Fotos verbleiben beim Nutzer. Der Nutzer räumt Beauly das Recht ein, diese zur Bereitstellung der Plattform-Funktionen zu verarbeiten. Der Nutzer ist für die Rechtmäßigkeit seiner Uploads verantwortlich.

7. Haftung
KI-generierte Inhalte dienen ausschließlich zur Orientierung. Beauly übernimmt keine Gewähr für Richtigkeit, Vollständigkeit oder Anwendbarkeit der Ergebnisse. Die Ergebnisse ersetzen keine professionelle Beratung. Die Haftung bei Vorsatz und grober Fahrlässigkeit bleibt unberührt.

8. Urheberrecht
Die Plattform und ihre Inhalte sind urheberrechtlich geschützt. KI-generierte Ergebnisse dürfen vom Nutzer frei verwendet werden.

9. Kündigung
Abonnements können jederzeit zum Ende des Abrechnungszeitraums gekündigt werden. Bei Kontolöschung werden alle Daten unwiderruflich gelöscht.

10. Schlussbestimmungen
Es gilt deutsches Recht. Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen unberührt.

Kontakt: info@wlbusinesscomputing.com`,
  },

  en: {
    impressum_title: "Legal Notice",
    privacy_title: "Privacy Policy",
    terms_title: "Terms of Service",
    legal_tooltip: "Legal",
    impressum: `Legal Notice

Plandirekt24
Unternehmergesellschaft (limited liability)

An der Hermannsquelle 12
23879 Mölln
Germany

Email: info@wlbusinesscomputing.com
Phone: +49 171 1277531
Website: beauly.club`,

    privacy: `Privacy Policy

1. General
Protecting your personal data is important to us. We process data exclusively in accordance with the GDPR. This policy informs about the type, scope, and purpose of data processing on the Beauly platform.

2. Controller
Plandirekt24 UG (limited liability)
Jonathan Weiß
An der Hermannsquelle 12, 23879 Mölln, Germany
Email: info@wlbusinesscomputing.com

3. Data We Process
Registration: Email address, password, optional name
Usage: Uploaded photos, chat history, usage data
Technical: IP address, browser type, access time

Legal basis: Art. 6(1)(b) GDPR (contract performance).

4. Uploaded Photos
Photos are processed for AI analysis and are not shared with third parties. The user is responsible for ensuring they are authorized to upload the content.

5. Chat History
Chat history is stored as long as the account exists. Users can delete it at any time. All data is removed upon account deletion.

6. AI Processing
Beauly uses AI systems for analysis and image generation. Results are automatically generated and serve as guidance — not professional advice. No automated decision-making pursuant to Art. 22 GDPR takes place.

7. Service Providers
We work with technical service providers for hosting, database, and AI processing. Data processing agreements pursuant to Art. 28 GDPR are in place.

8. Cookies
Beauly does not use tracking or advertising cookies.

9. Storage Duration
Data is only stored as long as necessary. All data is deleted upon account deletion. Payment data may be retained for up to 10 years due to legal obligations.

10. Your Rights
You have the right to access, rectification, erasure, restriction, data portability, and objection. Contact: info@wlbusinesscomputing.com

11. Changes
We reserve the right to update this policy as needed. The current version is always available on the website.`,

    terms: `Terms of Service

1. Scope
These Terms apply to the use of the Beauly platform, operated by Plandirekt24 UG (limited liability), An der Hermannsquelle 12, 23879 Mölln, Germany. By registering, you accept these Terms.

2. Service Description
Beauly is an AI-powered platform for analyzing and visualizing styling and appearance optimizations. The service includes AI analysis, image generation, and personalized recommendations. Uninterrupted availability is not guaranteed.

3. Registration
Registration with truthful information is required. Login credentials must be kept confidential. Minimum age: 18 years.

4. Prices and Payment
The use of Beauly is subject to fees. Details on prices and subscriptions are available on the platform. All prices are exclusive of VAT. Payment is processed through external payment providers. Amounts already paid are non-refundable.

5. User Obligations
Use for illegal purposes, distribution of malware, automated mass requests, and sharing of login credentials is prohibited. Access may be suspended for violations.

6. Uploaded Content
Rights to uploaded photos remain with the user. The user grants Beauly the right to process them for platform functionality. The user is responsible for the legality of their uploads.

7. Liability
AI-generated content is for guidance only. Beauly makes no guarantees regarding accuracy, completeness, or applicability of results. Results do not replace professional advice. Liability for intent and gross negligence remains unaffected.

8. Copyright
The platform and its content are protected by copyright. AI-generated results may be freely used by the user.

9. Termination
Subscriptions can be cancelled at any time at the end of the billing period. All data is irrevocably deleted upon account deletion.

10. Final Provisions
German law applies. If individual provisions are invalid, the remaining provisions remain effective.

Contact: info@wlbusinesscomputing.com`,
  },

  es: {
    impressum_title: "Aviso Legal",
    privacy_title: "Privacidad",
    terms_title: "Condiciones",
    legal_tooltip: "Legal",
    impressum: `Aviso Legal

Plandirekt24
Unternehmergesellschaft (responsabilidad limitada)

An der Hermannsquelle 12
23879 Mölln
Alemania

Correo: info@wlbusinesscomputing.com
Teléfono: +49 171 1277531
Web: beauly.club`,

    privacy: `Política de Privacidad

1. General
La protección de sus datos personales es importante para nosotros. Procesamos datos exclusivamente de acuerdo con el RGPD. Esta política informa sobre el tipo, alcance y propósito del procesamiento de datos en la plataforma Beauly.

2. Responsable
Plandirekt24 UG (responsabilidad limitada)
Jonathan Weiß
An der Hermannsquelle 12, 23879 Mölln, Alemania
Correo: info@wlbusinesscomputing.com

3. Datos que procesamos
Registro: Dirección de correo electrónico, contraseña, nombre opcional
Uso: Fotos subidas, historial de chat, datos de uso
Técnicos: Dirección IP, tipo de navegador, hora de acceso

Base legal: Art. 6(1)(b) RGPD (ejecución del contrato).

4. Fotos subidas
Las fotos se procesan para el análisis de IA y no se comparten con terceros. El usuario es responsable de estar autorizado para subir el contenido.

5. Historial de chat
El historial se almacena mientras la cuenta exista. Los usuarios pueden eliminarlo en cualquier momento. Todos los datos se eliminan al borrar la cuenta.

6. Procesamiento de IA
Beauly utiliza sistemas de IA para análisis y generación de imágenes. Los resultados se generan automáticamente y sirven como orientación, no como asesoramiento profesional.

7. Proveedores de servicios
Trabajamos con proveedores técnicos para hosting, base de datos y procesamiento de IA. Existen acuerdos de procesamiento de datos según el Art. 28 RGPD.

8. Cookies
Beauly no utiliza cookies de seguimiento ni publicitarias.

9. Duración del almacenamiento
Los datos solo se almacenan mientras sea necesario. Todos los datos se eliminan al borrar la cuenta.

10. Sus derechos
Tiene derecho a acceso, rectificación, supresión, limitación, portabilidad y oposición. Contacto: info@wlbusinesscomputing.com`,

    terms: `Condiciones de Uso

1. Ámbito
Estas condiciones se aplican al uso de la plataforma Beauly, operada por Plandirekt24 UG (responsabilidad limitada), An der Hermannsquelle 12, 23879 Mölln, Alemania. Al registrarse, acepta estas condiciones.

2. Descripción del servicio
Beauly es una plataforma impulsada por IA para analizar y visualizar optimizaciones de estilo y apariencia. El servicio incluye análisis de IA, generación de imágenes y recomendaciones personalizadas. No se garantiza una disponibilidad ininterrumpida.

3. Registro
Se requiere registro con información veraz. Las credenciales deben mantenerse confidenciales. Edad mínima: 18 años.

4. Precios y pago
El uso de Beauly es de pago. Los detalles sobre precios están disponibles en la plataforma. Todos los precios son sin IVA. Los importes pagados no son reembolsables.

5. Obligaciones del usuario
Está prohibido el uso para fines ilegales, distribución de malware, solicitudes masivas automatizadas y compartir credenciales. El acceso puede suspenderse por infracciones.

6. Contenido subido
Los derechos sobre las fotos subidas permanecen con el usuario. El usuario otorga a Beauly el derecho de procesarlas para la funcionalidad de la plataforma.

7. Responsabilidad
El contenido generado por IA es solo orientativo. Beauly no garantiza la exactitud ni aplicabilidad de los resultados. Los resultados no sustituyen el asesoramiento profesional.

8. Derechos de autor
La plataforma y su contenido están protegidos por derechos de autor. Los resultados generados por IA pueden ser utilizados libremente por el usuario.

9. Cancelación
Las suscripciones pueden cancelarse en cualquier momento al final del período de facturación. Todos los datos se eliminan irrevocablemente al borrar la cuenta.

10. Disposiciones finales
Se aplica la legislación alemana.

Contacto: info@wlbusinesscomputing.com`,
  },

  zh: {
    impressum_title: "法律声明",
    privacy_title: "隐私政策",
    terms_title: "使用条款",
    legal_tooltip: "法律信息",
    impressum: `法律声明

Plandirekt24
有限责任公司 (Unternehmergesellschaft)

An der Hermannsquelle 12
23879 Mölln
德国

邮箱: info@wlbusinesscomputing.com
电话: +49 171 1277531
网站: beauly.club`,

    privacy: `隐私政策

1. 概述
保护您的个人数据对我们非常重要。我们仅根据GDPR处理数据。本政策告知您Beauly平台上数据处理的类型、范围和目的。

2. 负责人
Plandirekt24 UG（有限责任）
Jonathan Weiß
An der Hermannsquelle 12, 23879 Mölln, 德国
邮箱: info@wlbusinesscomputing.com

3. 我们处理的数据
注册时：电子邮箱、密码、可选姓名
使用时：上传的照片、聊天记录、使用数据
技术数据：IP地址、浏览器类型、访问时间

法律依据：GDPR第6条第1款b项（合同履行）。

4. 上传的照片
照片用于AI分析处理，不会与第三方共享。用户有责任确保其有权上传相关内容。

5. 聊天记录
聊天记录在账户存续期间保存。用户可随时删除。账户删除时所有数据将被清除。

6. AI处理
Beauly使用AI系统进行分析和图像生成。结果为自动生成，仅供参考——不构成专业建议。不存在GDPR第22条意义上的自动化决策。

7. 服务提供商
我们与技术服务提供商合作进行托管、数据库和AI处理。已根据GDPR第28条签订数据处理协议。

8. Cookies
Beauly不使用跟踪或广告Cookies。

9. 存储期限
数据仅在必要时存储。账户删除时所有数据将被清除。支付数据可能因法律义务保留最长10年。

10. 您的权利
您有权访问、更正、删除、限制、数据可携和反对。联系方式：info@wlbusinesscomputing.com`,

    terms: `使用条款

1. 适用范围
本条款适用于Beauly平台的使用，该平台由Plandirekt24 UG（有限责任）运营，地址：An der Hermannsquelle 12, 23879 Mölln，德国。注册即表示接受本条款。

2. 服务描述
Beauly是一个AI驱动的平台，用于分析和可视化造型与外观优化。服务包括AI分析、图像生成和个性化建议。不保证服务不间断可用。

3. 注册
需要使用真实信息进行注册。登录凭据必须保密。最低年龄：18岁。

4. 价格和支付
使用Beauly需付费。价格和订阅详情可在平台上查看。所有价格不含增值税。已支付的金额不予退还。

5. 用户义务
禁止用于非法目的、传播恶意软件、自动化批量请求和共享登录凭据。违规可能导致访问被暂停。

6. 上传内容
上传照片的权利归用户所有。用户授权Beauly为提供平台功能而处理这些内容。用户对其上传内容的合法性负责。

7. 责任
AI生成的内容仅供参考。Beauly不保证结果的准确性、完整性或适用性。结果不能替代专业建议。

8. 版权
平台及其内容受版权保护。AI生成的结果可由用户自由使用。

9. 终止
订阅可在计费周期结束时随时取消。账户删除时所有数据将被不可撤销地删除。

10. 最终条款
适用德国法律。

联系方式：info@wlbusinesscomputing.com`,
  },
};

export default function LegalModal({ type, onClose }) {
  const { lang } = useLanguage();
  const l = LEGAL[lang] || LEGAL.en;

  const contentMap = { impressum: l.impressum, datenschutz: l.privacy, agb: l.terms };
  const titleMap = { impressum: l.impressum_title, datenschutz: l.privacy_title, agb: l.terms_title };

  const content = contentMap[type];
  const title = titleMap[type];

  if (!content) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div
        className="bg-white rounded-2xl shadow-xl max-w-lg w-full mx-4 max-h-[80vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-surface-border">
          <h2 className="font-display text-lg text-primary font-semibold">{title}</h2>
          <button onClick={onClose} className="text-text-muted hover:text-primary transition-colors">
            <X size={20} />
          </button>
        </div>
        <div className="overflow-y-auto px-6 py-4 text-sm text-text-secondary leading-relaxed whitespace-pre-line">
          {content}
        </div>
      </div>
    </div>
  );
}

export function LegalLinks({ className = "", dark = false }) {
  const { lang } = useLanguage();
  const l = LEGAL[lang] || LEGAL.en;
  const [openModal, setOpenModal] = useState(null);
  const linkClass = dark
    ? "hover:text-white transition-colors cursor-pointer"
    : "hover:text-primary transition-colors cursor-pointer";

  return (
    <>
      <span className={linkClass} onClick={() => setOpenModal("impressum")}>{l.impressum_title}</span>
      <span className={linkClass} onClick={() => setOpenModal("agb")}>{l.terms_title}</span>
      <span className={linkClass} onClick={() => setOpenModal("datenschutz")}>{l.privacy_title}</span>
      {openModal && <LegalModal type={openModal} onClose={() => setOpenModal(null)} />}
    </>
  );
}

export function LegalPopover() {
  const { lang } = useLanguage();
  const l = LEGAL[lang] || LEGAL.en;
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="text-text-muted hover:text-primary transition-colors p-1"
        title={l.legal_tooltip}
      >
        <Scale size={15} />
      </button>
      {open && (
        <div className="absolute bottom-full left-0 mb-2 bg-white border border-surface-border rounded-xl shadow-lg py-1 min-w-[120px] z-50">
          {[
            { type: "impressum", label: l.impressum_title },
            { type: "agb", label: l.terms_title },
            { type: "datenschutz", label: l.privacy_title },
          ].map(({ type, label }) => (
            <button
              key={type}
              onClick={() => { setOpenModal(type); setOpen(false); }}
              className="w-full text-left px-4 py-2 text-sm text-text-secondary hover:bg-surface transition-colors"
            >
              {label}
            </button>
          ))}
        </div>
      )}
      {openModal && <LegalModal type={openModal} onClose={() => setOpenModal(null)} />}
    </div>
  );
}
